module.exports = __webpack_public_path__ + "static/vokabox_teacher_landing-4d60e9d5b159971ae63dff9eebc5b098.png";